<template>
  <div>
    <div class="controls">
      <button class="btn btn-primary" @click="addRow">Add Row</button>
      <button class="btn btn-primary" @click="addColumn">Add Column</button>
      <button class="btn btn-danger" @click="removeRow" :disabled="tableData.length == 0">Remove Last Row</button>
      <button class="btn btn-danger" @click="removeColumn" :disabled="columnNames.length == 0">Remove Last Column</button>
    </div>

    <table v-if="tableData.length > 0" class="dynamic-table">
      <thead>
        <tr>
          <th v-for="(header, index) in columnNames" :key="index">
            <input v-model="columnNames[index]">
            <button @click="removeColumnAtIndex(index)" class="remove-col-btn">&times;</button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
          <td v-for="(cell, cellIndex) in row" :key="cellIndex">
            <input 
              v-model="tableData[rowIndex][cellIndex]" 
              type="text"
              @input="updateCell(rowIndex, cellIndex, $event.target.value)"
            >
            <!-- <button 
              v-if="rowIndex === 0" 
              @click="removeColumnAtIndex(cellIndex)" 
              class="remove-cell-btn"
            > 
              &times;
            </button>-->
          </td>
        </tr>
      </tbody>
    </table>

    <p v-else>No data. Add rows/columns to start.</p>
  </div>
</template>

<script>
export default {
  name: 'DynTable',
  data() {
    return {
      tableData: [],
      columnNames: []
    }
  },
  computed: {
   
  },
  methods: {
   addRow() {
      const newRow = Array(this.columnNames.length).fill('');
      this.tableData.push(newRow);
    },
    
    addColumn() {
      // Add new column with default name
      const newColumnName = `Column ${this.columnNames.length + 1}`;
      this.columnNames.push(newColumnName);
      
      // Add empty cell to all existing rows
      this.tableData.forEach(row => row.push(''));
    },
    
    removeRow() {
      if (this.tableData.length > 0) {
        this.tableData.pop();
      }
    },
    
    removeColumn() {
      if (this.columnNames.length > 0) {
        this.columnNames.pop();
        this.tableData.forEach(row => row.pop());
      }
    },
    
    removeColumnAtIndex(index) {
      if (this.columnNames.length > 1) {
        this.columnNames.splice(index, 1);
        this.tableData.forEach(row => row.splice(index, 1));
      }
    },
    
    updateCell(rowIndex, cellIndex, value) {
      this.$set(this.tableData[rowIndex], cellIndex, value);
    },

    updateColumnName(index, value) {
      this.$set(this.columnNames, index, value);
    }
  }
}
</script>

<style scoped>
.controls {
  margin-bottom: 15px;
}

.controls button {
  margin-right: 8px;
  padding: 5px 10px;
  cursor: pointer;
}

.dynamic-table {
  width: 100%;
  border-collapse: collapse;
}

.dynamic-table th,
.dynamic-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.dynamic-table th {
  background-color: #f2f2f2;
  position: relative;
}

.remove-col-btn,
.remove-cell-btn {
  background: none;
  border: none;
  color: red;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  right: 2px;
  top: 2px;
  font-size: 14px;
  padding: 0;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.remove-cell-btn {
  position: static;
  margin-left: 5px;
}

input {
  width: 100%;
  box-sizing: border-box;
  padding: 4px;
  border: 1px solid #ccc;
}
</style>